import { render, staticRenderFns } from "./CarouselWrapper.vue?vue&type=template&id=4c0f0558&scoped=true&"
import script from "./CarouselWrapper.vue?vue&type=script&lang=js&"
export * from "./CarouselWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f0558",
  null
  
)

export default component.exports